import { EsitlikTuru, IAlanI, AlanTipi } from '../../../interfaces/IAlan';
import { IGrupI } from '../../../interfaces/IGrup';
import { escapeRegex, turkceDuyarsizRegex, turkceKucuk } from '@/src/app/shared/utils/regex.utils';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChildren, EventEmitter, inject, Input, OnChanges, Output, QueryList, signal, SimpleChanges, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SablonDirective } from './sablon.directive';
import { FormsModule } from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFloatButtonComponent } from 'ng-zorro-antd/float-button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { IParametre } from '../../../interfaces/IParametre/IParametre';
import { parametredenFilitreAlanlariOlustur, kartTemelFilitreAlanlari, bilesenSecimAlaniOlustur, serbestAlanOlustur, dinamikBilesenFiltreAlaniOlustur, filtrelenebilirMi, IDinamikBilesenFiltreSet } from './parametre-filitre-yardimci';
import { FikoYTRequestService } from '@/src/app/shared/services/fikoyt-request.service';
import { FikoYTEnvIstemci } from '@/src/service/Environment/environment';

@Component({
    selector: 'fikoyt-fiko-filitreci',
    templateUrl: './fiko-filitreci.component.html',
    styleUrls: ['./fiko-filitreci.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, FormsModule, NzEmptyModule, NzButtonModule, NzDropdownModule, NzInputModule, NzSegmentedModule, NzDatePickerModule, NzModalModule, NzIconModule, NzSelectModule, NzAutocompleteModule, NzTooltipModule],
    providers: []
})
export class FikoFilitreciComponent implements AfterViewInit, OnChanges {
  @Input() sablon: IGrupI = {
    veVeya: "ve", acik: false, alanlar: []
  };

  @Output() sablonChange: EventEmitter<any> = new EventEmitter();

  @Output() enterBasildi: EventEmitter<any> = new EventEmitter();
  @Output() uygulaBasildi: EventEmitter<any> = new EventEmitter();
  @Output() temizleBasildi: EventEmitter<any> = new EventEmitter();

  /** Parametre modu: IParametre[] verilince otomatik IAlanI[] olusturur */
  @Input() parametreModu: boolean = false;

  /** Parametre listesi: parametreModu=true iken bu diziden filtre alanlari olusturulur */
  @Input() kartParametreleri: IParametre[] = [];

  /** Kart temel alanlari da eklensin mi (sahip, tarih, gizlilik, etiket) */
  @Input() temelAlanlarEkle: boolean = true;

  @Input() bilesenTipleri: {id: string; baslik: string; renk?: string; simge?: string}[] = [];

  @Input() hesapAlanlari: IAlanI[] = [];

  @Input() dinamikBilesenSetleri: IDinamikBilesenFiltreSet[] = [];

  @Input() siralamalar: { ismi: string; degeri: any }[] = [];
  @Input() siralama: any = { _id: -1 };
  @Output() siralamaDegisti = new EventEmitter<any>();

  siralamaSecildi(deger: any) {
    this.siralama = deger;
    this.siralamaDegisti.emit(deger);
  }

  siralamaKarsilastir = (o1: any, o2: any): boolean => JSON.stringify(o1) === JSON.stringify(o2);

  bilesenSeciliMi(alan: IAlanI, id: string): boolean {
    const secili = alan.degeri as string[] || [];
    return secili.includes(id);
  }

  bilesenToggle(alan: IAlanI, id: string) {
    let secili = (alan.degeri as string[] || []).slice();
    const idx = secili.indexOf(id);
    if (idx >= 0) secili.splice(idx, 1); else secili.push(id);
    alan.degeri = secili;
    this.sablonChange.emit(this.sablon);
  }

  private req = inject(FikoYTRequestService);
  uyeAramaSonuclari = signal<{_id: string; isim: string; soyIsim: string; resimId?: string; kullaniciAdi?: string}[]>([]);
  private _uyeAraTimeout: any;
  uyeSeciliMap = new Map<string, {isim: string; soyIsim: string; resimId?: string; kullaniciAdi?: string}>();

  uyeAra(arama: string) {
    clearTimeout(this._uyeAraTimeout);
    if (!arama?.trim()) { this.uyeAramaSonuclari.set([]); return; }
    this._uyeAraTimeout = setTimeout(async () => {
      const rx = turkceDuyarsizRegex(arama.trim());
      if (!rx) { this.uyeAramaSonuclari.set([]); return; }
      const sonuc = await this.req.aggregate<any>('FikoYT.sistem.DB.goUyeler.aggregate', [
        { $match: { silindi: { $ne: true }, $or: [
          { isim: { $regex: rx, $options: 'i' } },
          { soyIsim: { $regex: rx, $options: 'i' } },
          { kullaniciAdi: { $regex: rx, $options: 'i' } },
          { 'veri.pilesmi': { $regex: rx, $options: 'i' } }
        ]}},
        { $project: { isim: 1, soyIsim: 1, resimId: { $ifNull: ['$profilResmi', { $ifNull: ['$veri.resimId', ''] }] }, kullaniciAdi: 1 } },
        { $limit: 20 }
      ]);
      this.uyeAramaSonuclari.set(sonuc || []);
      this.CD.detectChanges();
    }, 300);
  }

  uyeSecildi(uyeId: string) {
    if (!uyeId) return;
    const uye = this.uyeAramaSonuclari().find(u => u._id === uyeId);
    if (uye) this.uyeSeciliMap.set(uyeId, { isim: uye.isim, soyIsim: uye.soyIsim, resimId: uye.resimId, kullaniciAdi: uye.kullaniciAdi });
  }

  uyeSeciliBilgi(uyeId: string): {isim: string; soyIsim: string; resimId?: string} | null {
    return this.uyeSeciliMap.get(uyeId) || null;
  }

  uyeResimUrl(resimId: string): string {
    if (!resimId) return '';
    const fapiUrl = FikoYTEnvIstemci?.adres?.fapiUrl || '';
    if (!fapiUrl) return '';
    return fapiUrl + '/fikoyt.com.FikoYT.sistem.dosyalar.' + resimId + '.resim?boyut=' + '32x?' + '&thumbnail=true';
  }

  // ═══════════════════════════════════════════
  // SERBEST ALAN (Wildcard Field Path)
  // ═══════════════════════════════════════════
  readonly SERBEST_ALAN_TIPLERI = ['📝 Yazı', '🔢 Sayı', '📅 Tarih'];
  private readonly SERBEST_TIP_MAP: string[] = ['yazı', 'sayı', 'tarih'];
  private readonly ESITLIK_YAZI: EsitlikTuru[] = ['=', '!=', 'içerir', 'içermez', 'Boş Olan', 'Boş Olmayan'];
  private readonly ESITLIK_SAYI: EsitlikTuru[] = ['=', '!=', '<', '<=', '>', '>=', 'aralık', 'Boş Olan', 'Boş Olmayan'];

  serbestAlanTipiDegisti(alan: IAlanI, idx: number) {
    alan.serbestAlanTipiIdx = idx;
    alan.serbestAlanTipi = this.SERBEST_TIP_MAP[idx] || 'yazı';
    alan.esitlikTurleri = alan.serbestAlanTipi === 'yazı' ? [...this.ESITLIK_YAZI] : [...this.ESITLIK_SAYI];
    alan.aktifEsitlikTuru = alan.serbestAlanTipi === 'yazı' ? 'içerir' : '=';
    alan.degeri = null;
    this.CD.detectChanges();
  }

  private readonly TEMEL_ALAN_YOLLARI = [
    '_id', 'sahip', 'tarih', 'vt', 'uygulama',
    'olusturmaTarihi', 'duzenlenmeTarihi',
    'etiketler.degeri', 'veri.konu',
  ];

  alanYoluOnerileri(aranan: string): string[] {
    const oneriler: string[] = [...this.TEMEL_ALAN_YOLLARI];
    for (const p of this.kartParametreleri || []) {
      if (filtrelenebilirMi(p)) {
        const yol = 'veri.icerikler.ek.' + p.ismi;
        if (!oneriler.includes(yol)) oneriler.push(yol);
      }
    }
    for (const db of this.dinamikBilesenSetleri || []) {
      for (const p of db.parametreler || []) {
        if (filtrelenebilirMi(p)) {
          const yol = 'veri.icerikler.ek.' + p.ismi;
          if (!oneriler.includes(yol)) oneriler.push(yol);
        }
      }
    }
    if (!aranan?.trim()) return oneriler;
    const kucuk = turkceKucuk(aranan.trim());
    return oneriler.filter(o => turkceKucuk(o).includes(kucuk));
  }

  // ═══════════════════════════════════════════
  // DİNAMİK BİLEŞEN FİLTRESİ
  // ═══════════════════════════════════════════
  dinamikBilesenParametreleriAl(bilesenId: string): any[] {
    const set = this.dinamikBilesenSetleri?.find(d => d.id === bilesenId);
    if (!set) return [];
    const params = (set.parametreler || []).filter(p => filtrelenebilirMi(p));
    // Hesap alanlarını parametre formatına çevirip listeye ekle (UI için)
    const hesaplar = (set.hesapAlanlari || []).map((h: any) => ({
      ismi: h.ismi,
      baslik: (h.simge || '🔢') + ' ' + h.baslik,
      turu: h.tipi === 'secim' ? 'Açılır Kutu'
          : h.tipi === 'sayı' ? 'Sayı'
          : h.tipi === 'tarih' ? 'Tarih'
          : h.tipi === 'olcu-uclu' ? 'Olcu Uclu'
          : h.tipi === 'olcu-sinir' ? 'Olcu Sinir'
          : 'Yazı',
      ayarlar: h.tipi === 'secim' ? { secenekler: h.secenekler, coklu: !!h.coklu } : {},
      _hesapAlani: true,
      _coklu: !!h.coklu,
      _ozelTip: h.tipi,
      _alanYolu: h.alanYolu || h.ismi,
    }));
    return [...params, ...hesaplar];
  }

  dinamikBilesenDegisti(alan: IAlanI, bilesenId: string) {
    alan.dinamikBilesenId = bilesenId;
    alan.dinamikBilesenAlanIsmi = null;
    alan._acilirSecenekler = null;
    const set = this.dinamikBilesenSetleri?.find(d => d.id === bilesenId);
    alan.dinamikBilesenSetId = set?.setId || null;
    alan.baslik = set ? (set.simge || '🧩') + ' ' + set.baslik : 'Dinamik Bileşen Filtresi';
    alan.degeri = null;
    this.CD.detectChanges();
  }

  dinamikBilesenAlanDegisti(alan: IAlanI, alanIsmi: string) {
    alan.dinamikBilesenAlanIsmi = alanIsmi;
    alan.degeri = null;
    alan._acilirSecenekler = null;
    alan._dbHesapAlani = false;
    alan._dbCoklu = false;
    const params = this.dinamikBilesenParametreleriAl(alan.dinamikBilesenId);
    const param: any = params.find(p => p.ismi === alanIsmi);
    if (!param) return;
    // Hesap alanı flagleri
    if (param._hesapAlani) {
      alan._dbHesapAlani = true;
      alan._dbCoklu = !!param._coklu;
      alan._dbAlanYolu = param._alanYolu || param.ismi;
    }
    const tip = param.turu;
    if (tip === 'Olcu Uclu') {
      // Gelişmiş esnek format: 1-3 ölçü, operatörler, aralıklar, wildcard
      alan.serbestAlanTipi = 'yazı';
      alan.esitlikTurleri = ['=', '!=', 'Boş Olan', 'Boş Olmayan'] as EsitlikTuru[];
      alan.aktifEsitlikTuru = '=';
      alan._ozelTip = 'olcu-uclu';
    } else if (tip === 'Olcu Sinir') {
      // Sıralı pozisyonel min/max sınırları (yeni gelişmiş)
      alan.serbestAlanTipi = 'yazı';
      alan.esitlikTurleri = ['Olan', 'Olmayan'] as EsitlikTuru[];
      alan.aktifEsitlikTuru = 'Olan' as any;
      alan._ozelTip = 'olcu-sinir';
      if (!alan._olcuSatirlari) {
        alan._olcuSatirlari = [
          { etiket: 'En küçük ölçü', min: null, max: null },
          { etiket: 'Orta ölçü',     min: null, max: null },
          { etiket: 'En büyük ölçü', min: null, max: null },
        ];
      }
    } else if (['Sayı', 'Para', 'İlerleme Çubuğu'].includes(tip)) {
      alan.serbestAlanTipi = 'sayı';
      alan.esitlikTurleri = [...this.ESITLIK_SAYI];
      alan.aktifEsitlikTuru = '=';
    } else if (['Tarih', 'Tarih Saat', 'Ay', 'Hafta', 'Saat'].includes(tip)) {
      alan.serbestAlanTipi = 'tarih';
      alan.esitlikTurleri = [...this.ESITLIK_SAYI];
      alan.aktifEsitlikTuru = '>=';
    } else if (['Açılır Kutu', 'Liste'].includes(tip)) {
      alan.serbestAlanTipi = 'yazı';
      // Çoklu seçim için: içerir/içermez (= birden fazla değer eşleşir)
      alan.esitlikTurleri = alan._dbCoklu
        ? ['içerir', 'içermez', 'Boş Olan', 'Boş Olmayan'] as EsitlikTuru[]
        : ['=', '!=', 'Boş Olan', 'Boş Olmayan'] as EsitlikTuru[];
      alan.aktifEsitlikTuru = alan._dbCoklu ? 'içerir' : '=';
      if (param.ayarlar?.secenekler) {
        alan._acilirSecenekler = param.ayarlar.secenekler.map((s: any) =>
          typeof s === 'string' ? { etiket: s, deger: s } : { etiket: s.etiket || s.label || s.deger, deger: s.deger ?? s.value }
        );
      }
      if (alan._dbCoklu) alan.degeri = [];
    } else if (['Doğruluk', 'Onay', 'Anahtar'].includes(tip)) {
      alan.serbestAlanTipi = 'yazı';
      alan.esitlikTurleri = ['=', '!='] as EsitlikTuru[];
      alan.aktifEsitlikTuru = '=';
      alan._acilirSecenekler = [{ etiket: 'Evet', deger: 'true' }, { etiket: 'Hayır', deger: 'false' }];
    } else {
      alan.serbestAlanTipi = 'yazı';
      alan.esitlikTurleri = [...this.ESITLIK_YAZI];
      alan.aktifEsitlikTuru = 'içerir';
    }
    this.CD.detectChanges();
  }

  @ContentChildren(SablonDirective) sablonListesi!: QueryList<SablonDirective>;

  varsayilanEsitlikTurleri: EsitlikTuru[] = ["=", "!=", "<", "<=", ">", ">="];

  @Input() alanlar: IAlanI[] = [
    // {
    //   alanIsmi: "dbo.TBLFATUIRS.FATIRS_NO",
    //   baslik: "Fiş Numarası",
    //   tipi: 'Yazı Kutusu',
    //   solSimge: "number",
    //   varsayilanDeger: "",
    //   yerTutucu: "Fiş Numarası",
    //   esitlikTurleri: ['=', '!=', "içerir", "içermez",],
    //   aktifEsitlikTuru!: 'içerir',
    // },
    // {
    //   alanIsmi: "dbo.TBLFATUIRS.CARI_KODU",
    //   baslik: "Müşteri Kodu",
    //   tipi: 'Yazı Kutusu',
    //   solSimge: "user",
    //   varsayilanDeger: "",
    //   yerTutucu: "Müşteri Kodu",
    //   esitlikTurleri: ['=', '!=', "içerir", "içermez",],
    //   aktifEsitlikTuru!: 'içerir',
    // },
    // {
    //   alanIsmi: "dbo.TBLCASABIT.CARI_ISIM",
    //   baslik: "Müşteri Adı",
    //   tipi: 'Yazı Kutusu',
    //   solSimge: "edit",
    //   varsayilanDeger: "",
    //   yerTutucu: "Müşteri Adı",
    //   esitlikTurleri: ['=', '!=', "içerir", "içermez",],
    //   aktifEsitlikTuru!: 'içerir',
    // },
    // {
    //   alanIsmi: "dbo.TBLFATUIRS.PLA_KODU",
    //   baslik: "Plasiyer Kodu",
    //   tipi: 'Yazı Kutusu',
    //   solSimge: "number",
    //   varsayilanDeger: "",
    //   yerTutucu: "Plasiyer Kodu",
    //   esitlikTurleri: ['=', '!=', "içerir", "içermez", "Boş Olan", "Boş Olmayan"],
    //   aktifEsitlikTuru!: '=',
    // },
  ]


  @Input() duzeltmeKurallari: any[] = [

  ]


  #fkId?: string;
  public get fkId(): string | any {
    return this.#fkId;
  }
  @Input() public set fkId(value: string) {
    this.#fkId = value;

    if (this.#fkId) {

    }
  }

  constructor(public CD: ChangeDetectorRef) {
    // setTimeout(() => { CD.detach(); }, 0);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['kartParametreleri'] || changes['parametreModu'] || changes['temelAlanlarEkle'] || changes['dinamikBilesenSetleri']) {
      if (this.parametreModu) {
        this.parametrelerdenAlanlariOlustur();
      }
    }
    if (changes['bilesenTipleri']) {
      this.bilesenTipleriAlanaEkle();
    }
  }

  private bilesenTipleriAlanaEkle() {
  }

  /** Parametre listesinden filtre alanlarini otomatik olusturur */
  parametrelerdenAlanlariOlustur() {
    let alanlar: IAlanI[] = [];
    if (this.temelAlanlarEkle) {
      alanlar = [...kartTemelFilitreAlanlari()];
    }
    if (this.kartParametreleri?.length) {
      alanlar = [...alanlar, ...parametredenFilitreAlanlariOlustur(this.kartParametreleri)];
    }
    if (this.bilesenTipleri?.length > 0) {
      alanlar = [...alanlar, bilesenSecimAlaniOlustur(this.bilesenTipleri)];
    }
    this.alanlar = alanlar;
    this.CD.detectChanges();
  }

  ngAfterViewInit(): void {
    //@ts-ignore
    // window.liste = this.sablonListesi;
  }

  ngOnDestroy() {

  }

  grupEkle(grup: IGrupI) {
    grup.alanlar!?.push({ veVeya: "ve", alanlar: [], acik: true });
    this.CD.detectChanges();
  }

  grupSil(grup: IGrupI, silObj: IGrupI & IAlanI) {
    const index = grup.alanlar!!.indexOf(silObj, 0);
    if (index > -1) {
      grup.alanlar!!.splice(index, 1);
      this.CD.detectChanges();
    }
  }

  alanEkle(grup: IGrupI) {
    grup.alanlar!?.push(Object.assign({}, this.alanlar![0]));
    this.CD.detectChanges();
  }

  alanSecimModalAcik = false;
  alanSecimArama = '';
  alanSecimHedefGrup: IGrupI | null = null;
  private alanDegistirIndex: number | null = null;

  alanDegistirModalAc(grup: IGrupI, index: number) {
    this.alanDegistirIndex = index;
    this.alanSecimModalAc(grup);
  }

  readonly ALAN_KATEGORI_TANIMI: { kategori: string; emoji: string; tipler: AlanTipi[] }[] = [
    { kategori: 'Metin Filtreleri', emoji: '📝', tipler: ['Yaz\u0131 Kutusu', '\u00C7oklu Yaz\u0131 Kutusu'] },
    { kategori: 'Say\u0131 Filtreleri', emoji: '🔢', tipler: ['Say\u0131 Kutusu'] },
    { kategori: 'Tarih Filtreleri', emoji: '📅', tipler: ['Tarih Kutusu'] },
    { kategori: 'Se\u00E7im Filtreleri', emoji: '☑️', tipler: ['\u00D6zel A\u00E7\u0131l\u0131r Kutu', 'Kayar Se\u00E7im Kutusu', '\u00DCye Se\u00E7imi'] },
  ];

  alanKategorileri: { kategori: string; emoji: string; alanlar: { alan: IAlanI; aciklama: string }[] }[] = [];

  alanSecimModalAc(grup: IGrupI) {
    this.alanSecimHedefGrup = grup;
    this.alanSecimArama = '';
    if (!this.alanDegistirIndex && this.alanDegistirIndex !== 0) this.alanDegistirIndex = null;
    this.alanKategorileriniGuncelle();
    this.alanSecimModalAcik = true;
    this.CD.detectChanges();
  }

  alanKategorileriniGuncelle() {
    const temelAlanlar = kartTemelFilitreAlanlari();
    const bilesenAlani = this.bilesenTipleri?.length > 0
      ? bilesenSecimAlaniOlustur(this.bilesenTipleri)
      : null;

    const temelKat: { kategori: string; emoji: string; alanlar: { alan: IAlanI; aciklama: string }[] } = {
      kategori: 'Temel Alanlar', emoji: '📋',
      alanlar: temelAlanlar.map(a => ({ alan: a, aciklama: a.tipi ?? '' }))
    };
    if (bilesenAlani) {
      temelKat.alanlar.push({ alan: bilesenAlani, aciklama: 'Kayit Turu' });
    }

    const paramAlanlar = this.kartParametreleri?.length
      ? parametredenFilitreAlanlariOlustur(this.kartParametreleri)
      : [];

    const katMap = new Map<string, { alan: IAlanI; aciklama: string }[]>();
    for (const t of this.ALAN_KATEGORI_TANIMI) {
      katMap.set(t.kategori, []);
    }

    for (const a of paramAlanlar) {
      const tipi = a.tipi;
      const hedef = this.ALAN_KATEGORI_TANIMI.find(k => k.tipler.includes(tipi!));
      const katIsmi = hedef ? hedef.kategori : 'Metin Filtreleri';
      katMap.get(katIsmi)!.push({ alan: a, aciklama: a.parametreTuru ?? a.tipi ?? '' });
    }

    const gelismisAlanlar: { alan: IAlanI; aciklama: string }[] = [
      { alan: serbestAlanOlustur(), aciklama: 'Herhangi bir alan yolu ile filtrele' },
    ];
    if (this.dinamikBilesenSetleri?.length > 0) {
      gelismisAlanlar.push({
        alan: dinamikBilesenFiltreAlaniOlustur(),
        aciklama: 'Dinamik bilesen verilerinde filtrele',
      });
    }

    this.alanKategorileri = [
      { kategori: 'Gelismis Filtreler', emoji: '\u26A1', alanlar: gelismisAlanlar },
      temelKat,
    ];

    for (const t of this.ALAN_KATEGORI_TANIMI) {
      const alanlar = katMap.get(t.kategori)!;
      if (alanlar.length > 0) {
        this.alanKategorileri.push({ kategori: t.kategori, emoji: t.emoji, alanlar });
      }
    }

    if (this.hesapAlanlari?.length > 0) {
      this.alanKategorileri.push({
        kategori: 'Hesaplanmis Alanlar', emoji: '\uD83D\uDCCA',
        alanlar: this.hesapAlanlari.map(a => ({ alan: a, aciklama: a.aciklama ?? 'Hesaplanmis' }))
      });
    }
  }

  get filtrelenmisKategoriler() {
    const ara = turkceKucuk(this.alanSecimArama?.trim() ?? '');
    if (!ara) return this.alanKategorileri.filter(k => k.alanlar.length > 0);
    return this.alanKategorileri
      .map(k => ({
        ...k,
        alanlar: k.alanlar.filter(a =>
          turkceKucuk(a.alan.baslik ?? '').includes(ara) ||
          turkceKucuk(a.aciklama ?? '').includes(ara)
        )
      }))
      .filter(k => k.alanlar.length > 0);
  }

  alanSecildi(secilen: { alan: IAlanI }) {
    if (!this.alanSecimHedefGrup) return;
    if (this.alanDegistirIndex != null) {
      this.alanSecimHedefGrup.alanlar![this.alanDegistirIndex] = Object.assign({}, secilen.alan);
      this.alanDegistirIndex = null;
    } else {
      this.alanSecimHedefGrup.alanlar!.push(Object.assign({}, secilen.alan));
    }
    this.alanSecimModalAcik = false;
    this.CD.detectChanges();
  }

  sablonBul(tipi: string) {
    return this.sablonListesi.find((item) => item.sablonTipi === tipi);
  }

  alanItemDegisti(grup: IGrupI, mevcutItemIndex:any, degisenItem: IAlanI) {
    // console.log(grup, mevcutItemIndex, degisenItem)
    if (mevcutItemIndex > -1) {
      grup.alanlar!![mevcutItemIndex] = Object.assign({}, degisenItem);
      this.CD.detectChanges();
    }
  }

  alanIcinSablonBul(alan: IAlanI) {
    if (!alan) return;
    const type = alan.tipi;
    if (type) {
      const queryInput = this.sablonBul(type);
      if (queryInput) {
        return queryInput.template;
      } else {
        // if (this.defaultTemplateTypes.indexOf(type) === -1) {
        // console.warn(`Could not find template for field with type: ${type}`);
        // }
        return null;
      }
    } else return;
  }

  /** trackBy: index bazli — genel listelerde kullanilir */
  trackByIndex(index: number): number {
    return index;
  }

  /** trackBy: alanIsmi bazli — alan dropdown listesi icin */
  trackByAlanIsmi(index: number, alan: IAlanI): string {
    return alan.alanIsmi ?? String(index);
  }

  sorguyuUret() {
    return [];
  }

  _sqlSiralamalar: string[] = [];
  alSiralama() {
    let sonuc = "";
    if (this._sqlSiralamalar.length > 0) {
      for (let i = 0; i < this._sqlSiralamalar.length; i++) {
        const sira = this._sqlSiralamalar[i];
        sonuc += sira;

        if (i != this._sqlSiralamalar.length - 1)
          sonuc += " + ";
      }
    }

    return sonuc;
  }


  toSql() {
    this._sqlSiralamalar = [];

    let isleAlan = (alan: IAlanI) => {
      let ceviriciEsitlik = {
        "=": "=",
        "!=": "!=",
        ">": ">",
        ">=": ">=",
        "<": "<",
        "<=": "<=",
        "içerir": "REGEXP",
        "içermez": "NOT REGEXP",
        "Olan": "IS NOT NULL",
        "Olmayan": "IS NULL",
        "Boş Olan": "IS NULL",
        "Boş Olmayan": "IS NOT NULL"
      };
      /** */
      let sonuc = ``;

      if (alan.cevirSQL) {
        return alan.cevirSQL(alan);
      }

      if (alan.tipi == 'Yazı Kutusu') {

        if (["=", "!=", ">", ">=", "<", "<="].indexOf(alan.aktifEsitlikTuru!!) > -1) {

          alan.degeri = this.degerDuzenle(alan.degeri);
          this.CD.detectChanges();
          sonuc += `${alan.alanIsmi}${ceviriciEsitlik[alan.aktifEsitlikTuru!!]}'${alan.degeri ?? ''}'`
        }
        if (["içerir", "içermez"].indexOf(alan.aktifEsitlikTuru!!) > -1) {
          alan.degeri = this.degerDuzenle(alan.degeri);
          this.CD.detectChanges();
          sonuc += `${alan.alanIsmi} ${ceviriciEsitlik[alan.aktifEsitlikTuru!!]} '${alan.degeri ?? ''}'`
        }
        if (["Boş Olan", "Olmayan"].indexOf(alan.aktifEsitlikTuru!!) > -1) {
          sonuc += `(${alan.alanIsmi} IS NULL OR ${alan.alanIsmi}='')`
        }
        if (["Boş Olmayan", "Olan"].indexOf(alan.aktifEsitlikTuru!!) > -1) {
          sonuc += `(${alan.alanIsmi} IS NOT NULL AND ${alan.alanIsmi}!='')`
        }
      }

      if (alan.tipi == 'Çoklu Yazı Kutusu') {
        let alanlar = alan.alanIsmi!.split("||");

        if (alan.degeri == "" || alan.degeri == null) {
          sonuc = "";
        } else {
          /** */
          sonuc += "("
          for (let i = 0; i < alanlar.length; i++) {
            const field = alanlar[i];

            let bolunmusDegerler = alan?.degeri?.split(" ") ?? [];

            alan.degeri = this.degerDuzenle(alan.degeri);
            this.CD.detectChanges();
            sonuc += "("

            sonuc += ` ${field} ${ceviriciEsitlik[alan.aktifEsitlikTuru!]} '%${alan.degeri ?? ''}%' OR `;

            if (alan?.siralama)
              if (alan?.degeri)
                this._sqlSiralamalar.push(alan?.siralama?.replaceAll("$filitreCumle", alan?.degeri));


            for (let k = 0; k < bolunmusDegerler?.length; k++) {
              const element = bolunmusDegerler[k];
              sonuc += `${field} ${ceviriciEsitlik[alan.aktifEsitlikTuru!]} '%${element ?? ''}%'`

              if (alan?.parcaliSiralama)
                if (element)
                  this._sqlSiralamalar.push(alan?.parcaliSiralama?.replaceAll("$filitreKelime", element));

              if (k != bolunmusDegerler.length - 1)
                sonuc += " AND ";
            }
            sonuc += ")"


            if (i != alanlar.length - 1) {
              sonuc += " OR ";
            }
          }

          sonuc += ") OR (FK.STOK_KODU IN (SELECT STOK_KODU FROM TBLSTOKBIL WHERE ("
          /** */
          // $arama4 .= ($arama1 != "" ? " AND " : "") . " REPLACE(REPLACE(dbo.TBLSTSABIT.STOK_KODU,'-',''),'/','') LIKE '%$item%'"
          // $arama3 .= ($arama3 != "" ? " AND " : "") . " BILGI LIKE '%$item%' ";
          // OR (FK.STOK_KODU IN (SELECT STOK_KODU FROM dbo.TBLSTOKBIL WHERE ($arama3) OR ($arama4)) ) )
          let bolunmusDegerler = alan?.degeri?.split(" ") ?? [];
          for (let i = 0; i < bolunmusDegerler.length; i++) {
            const bolunmus = bolunmusDegerler[i];
            sonuc += ` BILGI LIKE '%${bolunmus}%' `
            sonuc += ` OR BILGI LIKE '%${bolunmus.replaceAll('-', '')}%' `
            if (i != bolunmusDegerler.length - 1) {
              sonuc += " AND ";
            }
          }
          sonuc += `) OR (`
          for (let i = 0; i < bolunmusDegerler.length; i++) {
            const bolunmus = bolunmusDegerler[i];
            sonuc += ` REPLACE(REPLACE(FK.STOK_KODU,'-',''),'/','') LIKE '%${bolunmus}%' `
            sonuc += ` OR FK.STOK_KODU LIKE '%${bolunmus}%' `
            sonuc += ` OR FK.STOK_KODU LIKE '%${bolunmus.replaceAll('-', '')}%' `
            if (i != bolunmusDegerler.length - 1) {
              sonuc += " AND ";
            }
          }
          sonuc += `)))`


        }


        // console.log(sonuc);
        // console.log(this.alSiralama());
      }

      if (alan.tipi == 'Sayı Kutusu') {
        if (alan.degeri != '' && alan.degeri != null)
          if (["=", "!=", ">", ">=", "<", "<="].indexOf(alan.aktifEsitlikTuru!) > -1) {
            sonuc += `${alan.alanIsmi}${ceviriciEsitlik[alan.aktifEsitlikTuru!]}${parseFloat(alan.degeri) ?? ''}`
          }
        if (["Boş Olan", "Boş Olmayan", "Olan", "Olmayan"].indexOf(alan.aktifEsitlikTuru!) > -1) {
          sonuc += `${alan.alanIsmi} ${ceviriciEsitlik[alan.aktifEsitlikTuru!]} `
        }
      }


      if (alan.tipi == 'Kayar Seçim Kutusu') {
        // console.log(alan)
        sonuc += alan.ek.liste[alan.degeri].value;
      }

      return sonuc;
    }
    let isleGrup = (grup: IGrupI) => {
      let sonuc = ``;

      for (let i = 0; i < grup?.alanlar!?.length; i++) {
        const element = grup.alanlar![i];

        if ("veVeya" in element) {
          if (element.alanlar!.length > 0) {
            if (i != 0) {
              sonuc += `${grup.veVeya == 've' ? ' AND ' : ' OR '}`
            }
            sonuc += `( `;
            sonuc += isleGrup(element);
            sonuc += `) `;
          }
        } else {
          if (i != 0) {
            sonuc += `${grup.veVeya == 've' ? ' AND ' : ' OR '}`
          }
          sonuc += isleAlan(element);
        }

      }


      return sonuc;
    }

    let sonuc = isleGrup(this.sablon);

    this.sablonChange.emit(this.sablon);

    return sonuc;
  }

  degerDuzenle(deger:any) {
    let _sonuc = deger;

    for (let i = 0; i < this.duzeltmeKurallari?.length; i++) {
      const kural = this.duzeltmeKurallari[i];

      let $sartlar = kural.json.sartlar.split("||");
      for (let i = 0; i < $sartlar.length; i++) {
        const _sart = $sartlar[i];

        let regx = new RegExp(_sart, "ig")

        _sonuc = _sonuc?.replaceAll(regx, kural?.json?.degistirilecekMetin ?? "");
      }
    }

    return _sonuc;
  }



  static toSqlFromSablon(sablon: any, duzeltmeKurallari: any) {
    let siralamalar: any[] = [];

    let degerDuzenle = (deger : any) => {
      let _sonuc = deger;

      for (let i = 0; i < duzeltmeKurallari?.length; i++) {
        const kural = duzeltmeKurallari[i];

        let $sartlar = kural.json.sartlar.split("||");
        for (let i = 0; i < $sartlar.length; i++) {
          const _sart = $sartlar[i];

          let regx = new RegExp(_sart, "ig")

          _sonuc = _sonuc?.replaceAll(regx, kural?.json?.degistirilecekMetin ?? "");
        }
      }

      return _sonuc;
    }

    let isleAlan = (alan: IAlanI) => {
      let ceviriciEsitlik = {
        "=": "=",
        "!=": "!=",
        ">": ">",
        ">=": ">=",
        "<": "<",
        "<=": "<=",
        "içerir": "LIKE",
        "içermez": "NOT LIKE",
        "Olan": "IS NOT NULL",
        "Olmayan": "IS NULL",
        "Boş Olan": "IS NULL",
        "Boş Olmayan": "IS NOT NULL"
      };
      /** */
      let sonuc = ``;

      if (alan.cevirSQL) {
        return alan.cevirSQL(alan);
      }

      if (alan.tipi == 'Yazı Kutusu') {

        if (["=", "!=", ">", ">=", "<", "<="].indexOf(alan.aktifEsitlikTuru!) > -1) {

          alan.degeri = degerDuzenle(alan.degeri);
          // this.CD.detectChanges();
          sonuc += `${alan.alanIsmi}${ceviriciEsitlik[alan.aktifEsitlikTuru!]}'${alan.degeri ?? ''}'`
        }
        if (["içerir", "içermez"].indexOf(alan.aktifEsitlikTuru!) > -1) {
          alan.degeri = degerDuzenle(alan.degeri);
          // this.CD.detectChanges();
          sonuc += `${alan.alanIsmi} ${ceviriciEsitlik[alan.aktifEsitlikTuru!]} '${alan.degeri ?? ''}'`
        }
        if (["Boş Olan", "Olmayan"].indexOf(alan.aktifEsitlikTuru!) > -1) {
          sonuc += `(${alan.alanIsmi} IS NULL OR ${alan.alanIsmi}='')`
        }
        if (["Boş Olmayan", "Olan"].indexOf(alan.aktifEsitlikTuru!) > -1) {
          sonuc += `(${alan.alanIsmi} IS NOT NULL AND ${alan.alanIsmi}!='')`
        }
      }

      if (alan.tipi == 'Çoklu Yazı Kutusu') {
        let alanlar = alan.alanIsmi!.split("||");

        if (alan.degeri == "" || alan.degeri == null) {
          sonuc = "";
        } else {
          /** */
          sonuc += "("
          for (let i = 0; i < alanlar.length; i++) {
            const field = alanlar[i];

            let bolunmusDegerler = alan?.degeri?.split(" ") ?? [];

            alan.degeri = degerDuzenle(alan.degeri);
            // this.CD.detectChanges();
            sonuc += "("

            sonuc += ` ${field} ${ceviriciEsitlik[alan.aktifEsitlikTuru!]} '%${alan.degeri ?? ''}%' OR `;

            if (alan?.siralama)
              if (alan?.degeri)
                siralamalar.push(alan?.siralama?.replaceAll("$filitreCumle", alan?.degeri));


            for (let k = 0; k < bolunmusDegerler?.length; k++) {
              const element = bolunmusDegerler[k];
              sonuc += `${field} ${ceviriciEsitlik[alan.aktifEsitlikTuru!]} '%${element ?? ''}%'`

              if (alan?.parcaliSiralama)
                if (element)
                  siralamalar.push(alan?.parcaliSiralama?.replaceAll("$filitreKelime", element));

              if (k != bolunmusDegerler.length - 1)
                sonuc += " AND ";
            }
            sonuc += ")"


            if (i != alanlar.length - 1) {
              sonuc += " OR ";
            }
          }

          sonuc += ") OR (FK.STOK_KODU IN (SELECT STOK_KODU FROM TBLSTOKBIL WHERE ("
          /** */
          // $arama4 .= ($arama1 != "" ? " AND " : "") . " REPLACE(REPLACE(dbo.TBLSTSABIT.STOK_KODU,'-',''),'/','') LIKE '%$item%'"
          // $arama3 .= ($arama3 != "" ? " AND " : "") . " BILGI LIKE '%$item%' ";
          // OR (FK.STOK_KODU IN (SELECT STOK_KODU FROM dbo.TBLSTOKBIL WHERE ($arama3) OR ($arama4)) ) )
          let bolunmusDegerler = alan?.degeri?.split(" ") ?? [];
          for (let i = 0; i < bolunmusDegerler.length; i++) {
            const bolunmus = bolunmusDegerler[i];
            sonuc += ` BILGI LIKE '%${bolunmus}%' `
            sonuc += ` OR BILGI LIKE '%${bolunmus.replaceAll('-', '')}%' `
            if (i != bolunmusDegerler.length - 1) {
              sonuc += " AND ";
            }
          }
          sonuc += `) OR (`
          for (let i = 0; i < bolunmusDegerler.length; i++) {
            const bolunmus = bolunmusDegerler[i];
            sonuc += ` REPLACE(REPLACE(FK.STOK_KODU,'-',''),'/','') LIKE '%${bolunmus}%' `
            sonuc += ` OR FK.STOK_KODU LIKE '%${bolunmus}%' `
            sonuc += ` OR FK.STOK_KODU LIKE '%${bolunmus.replaceAll('-', '')}%' `
            if (i != bolunmusDegerler.length - 1) {
              sonuc += " AND ";
            }
          }
          sonuc += `)))`


        }


        // console.log(sonuc);
        // console.log(this.alSiralama());
      }

      if (alan.tipi == 'Sayı Kutusu') {
        if (alan.degeri != '' && alan.degeri != null)
          if (["=", "!=", ">", ">=", "<", "<="].indexOf(alan.aktifEsitlikTuru!) > -1) {
            sonuc += `${alan.alanIsmi}${ceviriciEsitlik[alan.aktifEsitlikTuru!]}${parseFloat(alan.degeri) ?? ''}`
          }
        if (["Boş Olan", "Boş Olmayan", "Olan", "Olmayan"].indexOf(alan.aktifEsitlikTuru!) > -1) {
          sonuc += `${alan.alanIsmi} ${ceviriciEsitlik[alan.aktifEsitlikTuru!]} `
        }
      }


      if (alan.tipi == 'Kayar Seçim Kutusu') {
        // console.log(alan)
        sonuc += alan.ek.liste[alan.degeri].value;
      }

      return sonuc;
    }
    let isleGrup = (grup: IGrupI) => {
      let sonuc = ``;

      for (let i = 0; i < grup?.alanlar!?.length; i++) {
        const element = grup.alanlar![i];

        if ("veVeya" in element) {
          if (element.alanlar!.length > 0) {
            if (i != 0) {
              sonuc += `${grup.veVeya == 've' ? ' AND ' : ' OR '}`
            }
            sonuc += `( `;
            sonuc += isleGrup(element);
            sonuc += `) `;
          }
        } else {
          if (i != 0) {
            sonuc += `${grup.veVeya == 've' ? ' AND ' : ' OR '}`
          }
          sonuc += isleAlan(element);
        }

      }


      return sonuc;
    }

    let sql;
    if ("veVeya" in sablon)
      sql = isleGrup(sablon);
    else
      sql = isleAlan(sablon);


    let siralama = "";
    if (siralamalar.length > 0) {
      // sonuc += "("
      for (let i = 0; i < siralamalar.length; i++) {
        const sira = siralamalar[i];
        siralama += sira;

        if (i != siralamalar.length - 1)
          siralama += " + ";
      }

      // sonuc += ")"
    }



    return [sql, siralama];
  }

  toMongo() {
    this._sqlSiralamalar = [];

    let isleAlan = (alan: IAlanI) => {
      return FikoFilitreciComponent._isleAlanMongo(alan);
    }

    let isleGrup = (grup: IGrupI) => {
      let sonuc:any = null;

      if ("veVeya" in grup) {
        if (grup.alanlar!!.length > 0) {
          if (grup.veVeya == 've') {
            sonuc = { "$and": [] };
          } else {
            sonuc = { "$or": [] };
          }
        }
      }

      for (let i = 0; i < grup?.alanlar!!.length; i++) {
        const element = grup.alanlar!![i];

        if ("veVeya" in element) {
          if (element.alanlar!.length > 0) {
            sonuc[Object.keys(sonuc)[0]].push(isleGrup(element))
          }
        } else {
          let _alnSrg = isleAlan(element);
          if (_alnSrg)
            sonuc[Object.keys(sonuc)[0]].push(_alnSrg)
        }

      }

      if (!sonuc)
        return sonuc;

      if (sonuc[Object.keys(sonuc)[0]].length > 0)
        return sonuc;
      else
        return null;
    }
    // console.log(this.sablon);
    let sonuc = isleGrup(this.sablon);

    // console.log(sonuc);

    this.sablonChange.emit(this.sablon);

    return sonuc;
  }

  /** Degerkosulu uretir (tip bazli: yazı/sayı/tarih) — serbest alan & dinamik bilesen icin ortak */
  private static _degerKosuluUret(alan: IAlanI): any {
    const tip = alan.serbestAlanTipi || 'yazı';
    if (tip === 'yazı') {
      switch (alan.aktifEsitlikTuru) {
        case 'içerir': return { $regex: turkceDuyarsizRegex(alan.degeri), $options: 'i' };
        case 'içermez': return { $not: { $regex: turkceDuyarsizRegex(alan.degeri), $options: 'i' } };
        case '=': return { $eq: alan.degeri };
        case '!=': return { $ne: alan.degeri };
        default: return null;
      }
    }
    if (tip === 'sayı') {
      // Aralık operatörü
      if (alan.aktifEsitlikTuru === 'aralık') {
        const min = (alan._aralikMin != null && alan._aralikMin !== ('' as any)) ? Number(alan._aralikMin) : null;
        const max = (alan._aralikMax != null && alan._aralikMax !== ('' as any)) ? Number(alan._aralikMax) : null;
        if (min == null && max == null) return null;
        const k: any = {};
        if (min != null && !isNaN(min)) k.$gte = min;
        if (max != null && !isNaN(max)) k.$lte = max;
        return k;
      }
      const num = alan.ek?.tamSayiCevir ? parseInt(alan.degeri) : parseFloat(alan.degeri);
      if (isNaN(num)) return null;
      switch (alan.aktifEsitlikTuru) {
        case '=': return { $eq: num };
        case '!=': return { $ne: num };
        case '>': return { $gt: num };
        case '>=': return { $gte: num };
        case '<': return { $lt: num };
        case '<=': return { $lte: num };
        default: return null;
      }
    }
    if (tip === 'tarih') {
      let tarih = alan.degeri;
      if (typeof tarih === 'string') tarih = new Date(tarih);
      switch (alan.aktifEsitlikTuru) {
        case '=': return { $eq: tarih };
        case '!=': return { $ne: tarih };
        case '>': return { $gt: tarih };
        case '>=': return { $gte: tarih };
        case '<': return { $lt: tarih };
        case '<=': return { $lte: tarih };
        default: return null;
      }
    }
    return null;
  }

  /** Serbest alan icin MongoDB sorgusu */
  private static _isleSerbestAlanMongo(alan: IAlanI): any {
    const alanYolu = alan.serbestAlanIsmi;
    if (!alanYolu) return null;
    const degeriYok = alan.aktifEsitlikTuru === 'Boş Olan' || alan.aktifEsitlikTuru === 'Olmayan';
    const degeriVar = alan.aktifEsitlikTuru === 'Boş Olmayan' || alan.aktifEsitlikTuru === 'Olan';
    if (degeriYok) return { [alanYolu]: { $in: [null, '', undefined] } };
    if (degeriVar) return { [alanYolu]: { $nin: [null, '', undefined], $exists: true } };
    if (alan.degeri == null || alan.degeri === '') return null;
    const kosul = FikoFilitreciComponent._degerKosuluUret(alan);
    return kosul ? { [alanYolu]: kosul } : null;
  }

  /** Dinamik bilesen filtresi icin MongoDB sorgusu ($elemMatch ile) */
  /** Olcu kısıt parse edicisi: "300x>=200,<=400xX×<5000" → [{op:'=',v:300},...,{op:'>=',v:200},{op:'<=',v:400},...,WILDCARD,...,{op:'<',v:5000}] */
  private static _olcuParseEt(ham: string): { op: string; v: number }[][] | null {
    if (!ham || !ham.trim()) return null;
    // Eksenleri x veya × ile ayır
    const eksenler = ham.split(/[x×]/i).map(e => e.trim());
    const sonuc: { op: string; v: number }[][] = [];
    for (const eksen of eksenler) {
      if (!eksen || eksen === '*' || eksen === '?') {
        sonuc.push([]); // wildcard: koşul yok
        continue;
      }
      // Aralık kısa formu: "200-400" → ">=200,<=400"
      const araliMatch = eksen.match(/^\s*(\d+\.?\d*)\s*-\s*(\d+\.?\d*)\s*$/);
      if (araliMatch) {
        sonuc.push([
          { op: '>=', v: parseFloat(araliMatch[1]) },
          { op: '<=', v: parseFloat(araliMatch[2]) },
        ]);
        continue;
      }
      // Virgülle ayrılmış AND koşulları: ">200,<400" → [>=200, <=400]
      const koşullar = eksen.split(',').map(k => k.trim()).filter(k => k);
      const grup: { op: string; v: number }[] = [];
      for (const k of koşullar) {
        // Operatör + sayı parse: "!=300", ">=200", ">2400", "2500"
        const m = k.match(/^(!=|>=|<=|>|<|=)?\s*(-?\d+\.?\d*)\s*$/);
        if (!m) return null; // hatalı format
        const op = m[1] || '=';
        const v = parseFloat(m[2]);
        if (isNaN(v)) return null;
        grup.push({ op, v });
      }
      if (grup.length === 0) return null;
      sonuc.push(grup);
    }
    return sonuc;
  }

  /** N kısıt grubunun M eksene permütasyonel olarak yerleştirilmesi için Mongo $expr sorgusu */
  private static _olcuPermutasyonSorgu(sorguYolu: string, kisitGruplari: { op: string; v: number }[][], aktifEsitlik: string): any {
    const eksenSay = 3; // kütük 3 boyutlu
    const N = kisitGruplari.length;
    if (N === 0) return null;
    if (N > eksenSay) return null;

    const opMap: any = { '=': '$eq', '!=': '$ne', '>': '$gt', '>=': '$gte', '<': '$lt', '<=': '$lte' };

    // Her permütasyon için: kısıt[i] eksen[perm[i]]'e atanır
    const permutasyonlar = FikoFilitreciComponent._permutasyonOlustur(eksenSay, N);

    const orKosullari: any[] = [];
    for (const perm of permutasyonlar) {
      const andlar: any[] = [];
      for (let i = 0; i < N; i++) {
        const eksenIdx = perm[i];
        const grup = kisitGruplari[i];
        if (grup.length === 0) continue; // wildcard
        for (const k of grup) {
          const op = opMap[k.op] || '$eq';
          andlar.push({ [op]: [{ $arrayElemAt: ['$' + sorguYolu, eksenIdx] }, k.v] });
        }
      }
      if (andlar.length === 0) {
        orKosullari.push({}); // her permütasyon eşleşir → her şey döner
      } else {
        orKosullari.push({ $and: andlar });
      }
    }

    // En az N ölçü olmalı (kütüğün ölçü array'i en az kısıt kadar uzun)
    const baseSize = { $gte: [{ $size: { $ifNull: ['$' + sorguYolu, []] } }, N] };

    // != mantığı: hiçbir permütasyon eşleşmemeli
    if (aktifEsitlik === '!=') {
      return { $expr: { $and: [baseSize, { $not: { $or: orKosullari } }] } };
    }
    return { $expr: { $and: [baseSize, { $or: orKosullari }] } };
  }

  /** k ekseninden N elemanlı sıralı tüm permütasyonları üret (k=3, N=2 → [[0,1],[0,2],[1,0],[1,2],[2,0],[2,1]]) */
  private static _permutasyonOlustur(k: number, N: number): number[][] {
    const sonuc: number[][] = [];
    const yardimci = (mevcut: number[], kalan: number[]) => {
      if (mevcut.length === N) { sonuc.push([...mevcut]); return; }
      for (let i = 0; i < kalan.length; i++) {
        mevcut.push(kalan[i]);
        const yeniKalan = [...kalan.slice(0, i), ...kalan.slice(i + 1)];
        yardimci(mevcut, yeniKalan);
        mevcut.pop();
      }
    };
    yardimci([], Array.from({ length: k }, (_, i) => i));
    return sonuc;
  }

  private static _isleDinamikBilesenMongo(alan: IAlanI): any {
    const bilesenId = alan.dinamikBilesenId;
    const setId = alan.dinamikBilesenSetId;
    const alanIsmi = alan.dinamikBilesenAlanIsmi;
    if (!bilesenId || !alanIsmi) return null;

    // Hesap alanı için gerçek MongoDB yolu (varsa _dbAlanYolu, yoksa alanIsmi)
    const sorguYolu = alan._dbAlanYolu || alanIsmi;

    // Özel tip: olcu-uclu (gelişmiş — 1-3 ölçü, operatörler, aralıklar, wildcard)
    if (alan._ozelTip === 'olcu-uclu' && alan._dbHesapAlani) {
      const degeriYok = alan.aktifEsitlikTuru === 'Boş Olan' || alan.aktifEsitlikTuru === 'Olmayan';
      const degeriVar = alan.aktifEsitlikTuru === 'Boş Olmayan' || alan.aktifEsitlikTuru === 'Olan';
      if (degeriYok) return { [sorguYolu]: { $in: [null, [], undefined] } };
      if (degeriVar) return { [sorguYolu]: { $exists: true, $ne: [] } };
      const ham = (alan.degeri || '').toString().trim();
      if (!ham) return null;
      const kisitGruplari = FikoFilitreciComponent._olcuParseEt(ham);
      if (!kisitGruplari || kisitGruplari.length === 0) return null;
      const sorgu = FikoFilitreciComponent._olcuPermutasyonSorgu(sorguYolu, kisitGruplari, alan.aktifEsitlikTuru as any);
      return sorgu;
    }
    // Özel tip: olcu-sinir (sıralı ölçü array'i, pozisyonel min/max sınırları)
    if (alan._ozelTip === 'olcu-sinir' && alan._dbHesapAlani) {
      const degeriYok = alan.aktifEsitlikTuru === 'Boş Olan' || alan.aktifEsitlikTuru === 'Olmayan';
      if (degeriYok) return { [sorguYolu]: { $in: [null, [], undefined] } };
      const satirlar = alan._olcuSatirlari as any[];
      const baseExists: any = { [sorguYolu]: { $exists: true, $ne: [] } };
      if (!satirlar?.length) return baseExists;
      const exprAndlar: any[] = [];
      for (let i = 0; i < satirlar.length; i++) {
        const s = satirlar[i] || {};
        const minN = (s.min != null && s.min !== '') ? Number(s.min) : null;
        const maxN = (s.max != null && s.max !== '') ? Number(s.max) : null;
        if (minN != null && !isNaN(minN)) {
          exprAndlar.push({ $gte: [{ $arrayElemAt: ['$' + sorguYolu, i] }, minN] });
        }
        if (maxN != null && !isNaN(maxN)) {
          exprAndlar.push({ $lte: [{ $arrayElemAt: ['$' + sorguYolu, i] }, maxN] });
        }
      }
      if (exprAndlar.length === 0) return baseExists;
      exprAndlar.unshift({ $gte: [{ $size: { $ifNull: ['$' + sorguYolu, []] } }, satirlar.length] });
      return { $expr: { $and: exprAndlar } };
    }

    const degeriYok = alan.aktifEsitlikTuru === 'Boş Olan' || alan.aktifEsitlikTuru === 'Olmayan';
    const degeriVar = alan.aktifEsitlikTuru === 'Boş Olmayan' || alan.aktifEsitlikTuru === 'Olan';

    // Çoklu seçim: array gelirse $in/$nin kullan
    const cokluSecim = alan._dbCoklu && Array.isArray(alan.degeri);
    let degerKosulu: any;

    if (degeriYok) {
      degerKosulu = { $in: [null, '', undefined] };
    } else if (degeriVar) {
      degerKosulu = { $nin: [null, '', undefined], $exists: true };
    } else if (cokluSecim) {
      const degerler = (alan.degeri as any[]).map(d => (d && typeof d === 'object' && 'deger' in d) ? d.deger : d).filter(d => d != null && d !== '');
      if (degerler.length === 0) return null;
      const negative = alan.aktifEsitlikTuru === 'içermez' || alan.aktifEsitlikTuru === '!=';
      degerKosulu = negative ? { $nin: degerler } : { $in: degerler };
    } else {
      // Aralık operatöründe degeri boş olabilir ama _aralikMin/Max dolu olabilir
      const aralikMod = alan.aktifEsitlikTuru === 'aralık';
      if (!aralikMod && (alan.degeri == null || alan.degeri === '')) return null;
      // Tek değer ama obje ise (acilirSecenek formatı) deger field'ını al
      const tekDeger = (alan.degeri && typeof alan.degeri === 'object' && 'deger' in alan.degeri) ? alan.degeri.deger : alan.degeri;
      // Hesap alanı + açılır seçenek (string seçimi): basit eşleşme
      if (alan._acilirSecenekler) {
        degerKosulu = alan.aktifEsitlikTuru === '!=' || alan.aktifEsitlikTuru === 'içermez'
          ? { $ne: tekDeger }
          : tekDeger;
      } else {
        // Sayı/tarih/yazı tipi: _degerKosuluUret operatörlere göre $gt, $lt, $eq vs. üretir
        const ham = { ...alan, degeri: tekDeger };
        degerKosulu = FikoFilitreciComponent._degerKosuluUret(ham);
        if (degerKosulu == null) return null;
      }
    }

    // Hesap alanı: üst seviye (ör: '_hesap.sonDurum') doğrudan ana karta sorgu
    if (alan._dbHesapAlani) {
      return { [sorguYolu]: degerKosulu };
    }

    // Normal parametre: veri.icerikler içinde elemMatch ile ara
    const setMatchers = [setId, 'hmi.' + bilesenId].filter(Boolean);
    return {
      'veri.icerikler': {
        $elemMatch: {
          $and: [
            { $or: [
              { 'ek.bilesen': bilesenId },
              ...(setMatchers.length ? [{ 'ek._secilenSetId': { $in: setMatchers } }] : []),
            ]},
            { ['ek.' + alanIsmi]: degerKosulu }
          ]
        }
      }
    };
  }

  /** Bir alan icin MongoDB sorgusu uretir (parametreFiltresi destekli) */
  static _isleAlanMongo(alan: IAlanI): any {
    let sonuc: any = null;

    if (alan.cevirMongoya) {
      return alan.cevirMongoya(alan);
    }

    if (alan.tipi === 'Serbest Alan') {
      return FikoFilitreciComponent._isleSerbestAlanMongo(alan);
    }
    if (alan.tipi === 'Dinamik Bileşen Filtresi') {
      return FikoFilitreciComponent._isleDinamikBilesenMongo(alan);
    }

    const degeriYok = alan.aktifEsitlikTuru === 'Boş Olan' || (alan.aktifEsitlikTuru as any) === 'Olmayan';
    const degeriVar = alan.aktifEsitlikTuru === 'Boş Olmayan' || (alan.aktifEsitlikTuru as any) === 'Olan';
    if (degeriYok || degeriVar) {
      sonuc = {};
      const degerKosuluBos = degeriYok
        ? { $in: [null, '', undefined] }
        : { $nin: [null, '', undefined], $exists: true };

      if (alan.parametreFiltresi && alan.parametreIsmi) {
        sonuc['parametreler'] = {
          $elemMatch: { ismi: alan.parametreIsmi, degeri: degerKosuluBos }
        };
      } else {
        sonuc[alan.alanIsmi!] = degerKosuluBos;
      }
      return sonuc;
    }

    if (alan.degeri == null || alan.degeri === '')
      return null;

    sonuc = {};

    let degerKosulu: any = null;

    // Sayi Kutusu
    if (alan.tipi == 'Sayı Kutusu') {
      // Aralık operatörü: min/max ayrı alanlardan
      if (alan.aktifEsitlikTuru === 'aralık') {
        const min = (alan._aralikMin != null && alan._aralikMin !== ('' as any)) ? Number(alan._aralikMin) : null;
        const max = (alan._aralikMax != null && alan._aralikMax !== ('' as any)) ? Number(alan._aralikMax) : null;
        if (min == null && max == null) return null;
        const k: any = {};
        if (min != null && !isNaN(min)) k.$gte = min;
        if (max != null && !isNaN(max)) k.$lte = max;
        degerKosulu = k;
      } else {
        let deger = alan.degeri;
        if (deger) {
          deger = alan.ek?.tamSayiCevir ? Number.parseInt(deger) : Number.parseFloat(deger);
        }

        switch (alan.aktifEsitlikTuru!) {
          case "=": degerKosulu = { $eq: deger }; break;
          case "!=": degerKosulu = { $ne: deger }; break;
          case ">": degerKosulu = { $gt: deger }; break;
          case ">=": degerKosulu = { $gte: deger }; break;
          case "<": degerKosulu = { $lt: deger }; break;
          case "<=": degerKosulu = { $lte: deger }; break;
        }
      }
    }

    // Yazi Kutusu
    if (alan.tipi == 'Yazı Kutusu') {
      switch (alan.aktifEsitlikTuru!) {
        case "içerir":
          degerKosulu = { $regex: turkceDuyarsizRegex(alan.degeri), $options: "i" };
          break;
        case "içermez":
          degerKosulu = { $not: { $regex: turkceDuyarsizRegex(alan.degeri), $options: "i" } };
          break;
        case "=":
          degerKosulu = { $eq: alan.degeri };
          break;
        case "!=":
          degerKosulu = { $ne: alan.degeri };
          break;
      }
    }

    // Tarih Kutusu
    if (alan.tipi == 'Tarih Kutusu') {
      let tarihDeger = alan.degeri;
      if (typeof tarihDeger === 'string') {
        tarihDeger = new Date(tarihDeger);
      }

      switch (alan.aktifEsitlikTuru!) {
        case "=": degerKosulu = { $eq: tarihDeger }; break;
        case "!=": degerKosulu = { $ne: tarihDeger }; break;
        case ">": degerKosulu = { $gt: tarihDeger }; break;
        case ">=": degerKosulu = { $gte: tarihDeger }; break;
        case "<": degerKosulu = { $lt: tarihDeger }; break;
        case "<=": degerKosulu = { $lte: tarihDeger }; break;
      }
    }

    // Kayar Secim Kutusu
    if (alan.tipi == 'Kayar Seçim Kutusu') {
      const secilenDeger = alan.ek?.liste?.[alan.degeri]?.value;
      if (secilenDeger === null || secilenDeger === undefined) return null;
      degerKosulu = secilenDeger;
    }

    // Ozel Acilir Kutu
    if (alan.tipi == 'Özel Açılır Kutu') {
      const ham = alan.degeri?.degeri ?? alan.degeri;
      degerKosulu = alan.aktifEsitlikTuru === '!=' ? { $ne: ham } : ham;
    }

    // Uye Secimi
    if (alan.tipi === 'Üye Seçimi') {
      const alanAdi = alan.alanIsmi || alan.ismi;
      if (!alan.degeri) return null;
      return { [alanAdi!]: alan.aktifEsitlikTuru === '!=' ? { $ne: alan.degeri } : alan.degeri };
    }

    // Bilesen Secimi
    if (alan.tipi === 'Bileşen Seçimi') {
      const secili = alan.degeri as string[] || [];
      const esitlik = alan.aktifEsitlikTuru as string;
      if (esitlik === 'Boş Olan') {
        return { 'veri.icerikler.ek.bilesen': { $in: [null, '', undefined] } };
      }
      if (esitlik === 'Boş Olmayan') {
        return { 'veri.icerikler.ek.bilesen': { $nin: [null, '', undefined], $exists: true } };
      }
      if (secili.length === 0) return {};
      const bilesenKosul = {
        $or: [
          { 'veri.icerikler.ek.bilesen': { $in: secili } },
          { 'veri.icerikler.ek._secilenSetId': { $in: secili.map(t => 'hmi.' + t) } }
        ]
      };
      if (esitlik === 'içermez') {
        return { $nor: bilesenKosul.$or };
      }
      return bilesenKosul;
    }

    if (degerKosulu == null) return null;

    if (alan.prepipeAlani) {
      sonuc[alan.prepipeAlani] = degerKosulu;
    } else if (alan.parametreFiltresi && alan.parametreIsmi) {
      sonuc['parametreler'] = {
        $elemMatch: { ismi: alan.parametreIsmi, degeri: degerKosulu }
      };
    } else {
      sonuc[alan.alanIsmi!] = degerKosulu;
    }

    return sonuc;
  }

  /** Grup icin MongoDB sorgusu uretir */
  static _isleGrupMongo(grup: IGrupI): any {
    let sonuc: any = null;

    if ("veVeya" in grup) {
      if (grup.alanlar!!.length > 0) {
        sonuc = grup.veVeya == 've' ? { "$and": [] } : { "$or": [] };
      }
    }

    for (let i = 0; i < grup?.alanlar!!.length; i++) {
      const element = grup.alanlar!![i];

      if ("veVeya" in element) {
        if (element.alanlar!.length > 0) {
          const altSorgu = FikoFilitreciComponent._isleGrupMongo(element);
          if (altSorgu) sonuc[Object.keys(sonuc)[0]].push(altSorgu);
        }
      } else {
        let _alnSrg = FikoFilitreciComponent._isleAlanMongo(element);
        if (_alnSrg) sonuc[Object.keys(sonuc)[0]].push(_alnSrg);
      }
    }

    if (!sonuc) return sonuc;
    if (sonuc[Object.keys(sonuc)[0]].length > 0) return sonuc;
    return null;
  }

  /** Sablon uzerinden statik MongoDB sorgusu olusturur */
  static toMongoFromSablon(sablon: IGrupI): any {
    if ("veVeya" in sablon)
      return FikoFilitreciComponent._isleGrupMongo(sablon);
    else
      return FikoFilitreciComponent._isleAlanMongo(sablon as any);
  }

  static sablondaPrepipeVarMi(sablon: IGrupI): boolean {
    const kontrol = (grup: IGrupI): boolean => {
      for (const eleman of grup.alanlar || []) {
        if ('veVeya' in eleman) {
          if (kontrol(eleman)) return true;
        } else {
          if ((eleman as IAlanI).prepipeAlani) return true;
        }
      }
      return false;
    };
    return kontrol(sablon);
  }

  /** Parametre listesinden alanlar olusturur (statik, disaridan cagrilabilir) */
  static parametredenAlanlar = parametredenFilitreAlanlariOlustur;
  static kartTemelAlanlar = kartTemelFilitreAlanlari;
}

